"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SubCondition_1 = require("./SubCondition");
var lodash_1 = require("lodash");
var Field_1 = require("../../constants/Field");
var ConditionOut_1 = require("./ConditionOut");
var ConditionIn = /** @class */ (function () {
    function ConditionIn() {
    }
    ConditionIn.fromJson = function (name, json) {
        var conditionIn = new ConditionIn();
        conditionIn.name = name;
        var subConditionsJson = json[Field_1.FIELD.SUBCONDITIONS];
        var subConditions = lodash_1.map(Object.keys(subConditionsJson), function (subConditionName) {
            var subCondition = SubCondition_1.SubCondition.fromJson(subConditionName, subConditionsJson[subConditionName]);
            return subCondition;
        });
        conditionIn.subConditions = subConditions;
        return conditionIn;
    };
    ConditionIn.prototype.toJson = function (includeOnlyValueOrLink) {
        var subConditions = {};
        lodash_1.map(this.subConditions, function (subCondition) {
            subConditions = Object.assign(subConditions, subCondition.toJson(includeOnlyValueOrLink));
        });
        var subConditionJson = Object.create(null);
        var json = {};
        if (!lodash_1.isEmpty(subConditions)) {
            subConditionJson[Field_1.FIELD.SUBCONDITIONS] = subConditions;
            json[this.name] = subConditionJson;
        }
        return json;
    };
    /**
     * Creates output condition object from input condition.
     * @returns Output Condition object of type
     */
    ConditionIn.prototype.toConditionOut = function () {
        var subConditionNames = lodash_1.map(this.subConditions, function (subCondition) {
            return subCondition.name;
        });
        var conditionOut = new ConditionOut_1.ConditionOut(this.name, subConditionNames);
        return conditionOut;
    };
    return ConditionIn;
}());
exports.ConditionIn = ConditionIn;
//# sourceMappingURL=ConditionIn.js.map